import {useApi} from "~/composables/api/utils/useApi"

export const useAuthApi = () => ({
  async login(email, password) {
    const url = `/auth/login`
    const api = useApi()

    return api.makeRequest(url, 'post', {email, password})
  },
  async activate(token) {
    const url = `/auth/confirmation`
    const api = useApi()

    return api.makeRequest(url, 'post', {token})
  },
  async requestNewPassword(email) {
    const url = `/auth/forgotten-password`
    const api = useApi()

    await api.makeRequest(url, 'post', {email})
  },
  async changePassword(token, password, passwordRepeated) {
    const url = `/auth/change-password`
    const api = useApi()

    return api.makeRequest(url, 'put', {token, password, repeated_password: passwordRepeated})
  }
})
